export function containsOnlyAlphanumeric(inputString) {
    const nonAlphanumericPattern = /[^A-Za-z0-9]/;
  
    return !nonAlphanumericPattern.test(inputString);
 }